export const features = [
  {
    icon: 'ri-group-line',
    title: '多人实时协同编辑',
    description: '支持多人同时编辑同一份文档，所有修改实时同步，告别版本混乱和反复传文件。',
  },
  {
    icon: 'ri-history-line',
    title: '完整版本历史',
    description: '自动记录每一次修改，支持任意版本回溯与对比，再也不用担心误操作导致内容丢失。',
  },
  {
    icon: 'ri-chat-thread-line',
    title: '精准批注与讨论',
    description: '在文档任意位置添加批注，@同事发起讨论。沟通就在上下文，不用切换到聊天工具。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '精细化权限控制',
    description: '支持编辑、批注、只读等不同权限级别，可精确到段落级别设置访问权限，安全合规。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝同步',
    description: 'Web、iOS、Android三端全覆盖，所有修改实时同步，随时随地参与协作。',
  },
  {
    icon: 'ri-file-copy-line',
    title: '丰富模板库',
    description: '内置合同、方案、报告等数百种专业模板，一键创建，快速启动起草工作。',
  },
];

export const useCases = [
  {
    icon: 'ri-building-2-line',
    title: '企业法务',
    description: '合同起草、审阅与版本管理，让法务团队协作更高效',
  },
  {
    icon: 'ri-advertisement-line',
    title: '市场营销',
    description: '营销方案、品牌文案、广告脚本的协同创作与评审',
  },
  {
    icon: 'ri-terminal-box-line',
    title: '技术团队',
    description: '技术规范、API文档、产品说明书的协同编写与维护',
  },
  {
    icon: 'ri-article-line',
    title: '内容创作',
    description: '公众号文章、视频脚本、创意内容的团队协作撰写',
  },
  {
    icon: 'ri-government-line',
    title: '政府机关',
    description: '政策文件、工作报告的多人起草与逐级审核',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: '学术研究',
    description: '学术论文、研究报告的合著撰写与导师审阅',
  },
];

export const stats = [
  { value: '500,000+', label: '活跃用户' },
  { value: '10,000+', label: '企业客户' },
  { value: '99.9%', label: '服务可用性' },
  { value: '200+', label: '支持国家与地区' },
];

export const testimonials = [
  {
    name: '王磊',
    role: '某科技公司法务总监',
    content: '以前一份合同要在法务、业务和外部律师之间来回传十几次，版本根本管不过来。用了一起草之后，所有人同时在文档上协作，合同起草周期从两周缩短到了三天，效率提升太明显了。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20business%20attire%2C%20warm%20studio%20lighting%2C%20clean%20white%20background%2C%20friendly%20professional%20headshot&width=100&height=100&seq=avatar-wl&orientation=squarish',
  },
  {
    name: '陈雅文',
    role: '某广告公司创意总监',
    content: '创意团队最怕的就是信息不同步。一起草让我们的文案、设计和策略团队能同时看到最新版本，批注功能让反馈变得特别高效。现在我们所有的创意方案都在一起草上完成，再也不用在微信群里翻聊天记录了。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20creative%20industry%20attire%2C%20warm%20studio%20lighting%2C%20clean%20white%20background%2C%20confident%20friendly%20headshot&width=100&height=100&seq=avatar-cyw&orientation=squarish',
  },
  {
    name: '刘建国',
    role: '某制造企业总经理',
    content: '我们工厂分布在三个城市，以前开会讨论文件要提前发邮件、打印、传真，效率极低。一起草让三地的管理团队能同时在线上编辑和讨论文件，实时看到彼此的修改，沟通效率提升了好几倍。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20executive%20portrait%2C%20warm%20studio%20lighting%2C%20clean%20white%20background%2C%20experienced%20friendly%20headshot&width=100&height=100&seq=avatar-ljg&orientation=squarish',
  },
];